export const SET_NOTIFICATION_COUNT = 'notifications/SET_COUNT';

export const setNotificationCount = payload => ({
  type: SET_NOTIFICATION_COUNT,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/set-notification-count.js